<template>
    <b-card no-body>
        <b-overlay :show="getting" opacity="0.2">
            <div class="p-75">
                <div class="row">
                    <div class="col-lg-2 mb-1 mb-lg-0">
                        <v-date-picker v-model="date" range placeholder="Tarih Aralığı"></v-date-picker>
                    </div>
                    <div class="col-md-2 mb-1 mb-md-0">             
                        <b-input-group class="input-group-merge">
                            <template #prepend>
                                <b-input-group-text >
                                    <feather-icon icon="SearchIcon"></feather-icon>
                                </b-input-group-text>
                            </template>
                            <b-form-input placeholder="Personel Ara..." v-on:keyup.enter="getData" v-model="searchValue"></b-form-input>
                        </b-input-group>
                    </div>
                    <div class="col-md-2 mb-1 mb-md-0">
                        <select class="form-control" v-model="order">
                            <option v-for="opt in orders" :value="opt.id" :key="opt.id">
                                {{ opt.header }} ({{ opt.asc ? 'Küçükten Büyüğe' : 'Büyükten Küçüğe' }})
                            </option>
                        </select>
                    </div>
                    <div class="col-md-auto mb-1 mb-md-0">
                        <button class="btn btn-success btn-block" v-on:click="getData">
                            Sorgula
                        </button>
                    </div>
                    <div class="col-auto" v-if="excelPath">
                        <button class="btn btn-outline-success" v-on:click="downloadExcel">Excel</button>
                    </div>
                </div>
            </div>
            <div class="px-75 pb-75">
                <div class="row">
                    <div class="col-md-4 mb-1 mb-md-0">
                        <v-stats-box
                            text="Toplam Personel Tutar"
                            variant="warning"
                            icon="person"
                            :value="summary.totalDriverAmountStr"
                        ></v-stats-box>
                    </div>
                    <div class="col-md-4 mb-1 mb-md-0">
                        <v-stats-box
                            text="Toplam Firma Tutar"
                            variant="info"
                            icon="corporate_fare"
                            :value="summary.totalCompanyAmountStr"
                        ></v-stats-box>
                    </div>
                    <div class="col-md-4">
                        <v-stats-box
                            text="Toplam Ceza Tutar"
                            variant="success"
                            icon="request_page"
                            :value="summary.totalFineAmountStr"
                        ></v-stats-box>
                    </div>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table  table-sm bordered-header">
                    <thead>
                        <tr>
                            <th></th>
                            <th class="text-nowrap w-20">Personel</th>
                            <th class="text-nowrap w-16">TCKN</th>
                            <th class="text-nowrap w-16">Performans Ceza Puanı</th>
                            <th class="text-nowrap w-16">Personel Toplam Tutar</th>
                            <th class="text-nowrap w-16">Firma Toplam Tutar</th>
                            <th class="text-nowrap w-16">Toplam Ceza Tutar</th>
                        </tr>
                        
                    </thead>
                    <tbody>
                        <template v-for="(d,i) in datas">
                            <tr :key="i" :class="{'bg-light-warning':d._expand}">
                                <td>
                                    <button class="btn btn-icon btn-xs btn-outline-warning" v-on:click="d._expand = !d._expand">
                                        <feather-icon :icon="d._expand ? 'ChevronDownIcon': 'ChevronRightIcon'"/>
                                    </button>
                                </td>
                                <td class="text-nowrap">{{ d.FullName }}</td>
                                <td class="text-nowrap">{{ d.IdentityNumber }}</td>
                                <td class="text-nowrap">{{ d.TotalPoint }}</td>
                                <td class="text-nowrap">{{ d.TotalDriverAmountStr }}</td>
                                <td class="text-nowrap">{{ d.TotalCompanyAmountStr }}</td>
                                <td class="text-nowrap font-weight-bolder">{{ d.TotalFineAmountStr }}</td>
                            </tr>
                            <tr v-if="d._expand" :key="`e-${i}`">
                                <td colspan="200" class="p-1">
                                    <div class="row">
                                        <div class="col-md-2 mb-1">
                                            <v-stats-box 
                                                text="Toplam Puan" 
                                                variant="info" 
                                                icon="control_point" 
                                                :value="d.TotalPoint"></v-stats-box>
                                        </div>
                                        <div class="col-md-10 mb-1">
                                            <v-stats-box 
                                                text="En Fazla Ceza Türü" 
                                                variant="secondary" 
                                                icon="car_crash" 
                                                :value="d.TopFineDescription"></v-stats-box>
                                        </div>
                                    </div>
                                    <div class="border-right border-left border-bottom">
                                        <table class="table table-hover table-sm bordered-header">
                                            <thead>
                                                <tr>
                                                    <th>Yıl</th>
                                                    <th>Ceza Puanı</th>
                                                    <th>Personel Tutar</th>
                                                    <th>Firma Tutar</th>
                                                    <th>Toplam Tutar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(f,ii) in d.Fines" :key="ii">
                                                    <td>{{ f.Year }}</td>
                                                    <td>{{ f.Point }}</td>
                                                    <td>{{ f.DriverAmountStr }}</td>
                                                    <td>{{ f.CompanyAmountStr }}</td>
                                                    <td class="font-weight-bolder">{{ f.FineAmountStr }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                        </template>
                        <tr v-if="(datas || []).length == 0">
                            <td colspan="100" class="text-center">Henüz bir veri bulunmamaktadır.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="(datas || []).length" class="mx-75 mb-1">
                <div class="row justify-content-md-between justify-content-center">
                    <div class="col-auto mb-1 mb-md-0">
                        <div class="d-flex align-items-center text-nowrap">
                            Toplam {{(count || 0)}} kayıt arasından
                            <select class="form-control form-control-sm mx-50 per-page-select" v-model="perPage">
                                <option v-for="pp in perPages" :key="pp" :value="pp">{{pp}}</option>
                            </select>
                            gösteriliyor.
                        </div>
                    </div>
                    <div class="col-auto mb-1 mb-md-0">
                        <b-pagination class="mb-0" v-model="page" :total-rows="((count || 0))" :per-page="perPage"></b-pagination>
                    </div>
                </div>
            </div>
        </b-overlay>
    </b-card>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations';
import { BCard, BPagination, BOverlay, BInputGroup, BInputGroupText, BFormInput, } from 'bootstrap-vue';
import VStatsBox from '@/components/VStatsBox.vue'
import Additional from '@/utilities/additional';

export default{
    components:{
        BCard,
        BPagination,
        BOverlay,
        VStatsBox, 
        BInputGroup, 
        BInputGroupText, 
        BFormInput,
    },
    data(){
        return {
            datas:[],
            date:[],
            order:'FullName-true',
            perPages:[10,20,30,40,50,100],
            perPage:10,
            page:1,
            count:0,
            searchValue:'',
            excelPath:null,
            getting: false,
            summary: {
                totalDriverAmountStr: '0,00 ₺',
                totalCompanyAmountStr: '0,00 ₺',
                totalFineAmountStr: '0,00 ₺',
            },
            columns:[
                {
                    key:'FullName',
                    header:'Personel'
                },
                {
                    key:'TotalPoint',
                    header:'Toplam Puan'
                },
                {
                    key:'TotalDriverAmount',
                    header:'Personel Toplam Tutar'
                },
                {
                    key:'TotalCompanyAmount',
                    header:'Firma Toplam Tutar'
                },
                {
                    key:'TotalFineAmount',
                    header:'Toplam Ceza Tutar'
                }
            ]
        }
    },
    mounted(){
        this.getData()
    },
    methods:{
        downloadExcel(){
            if(this.excelPath){
                Additional.DownloadTab(this.excelPath)
            }
        },
        getData(){
            this.getting = true
            const o = this.orders.find(oo => oo.id == this.order)

            EmployeeOperationsApi.TrafficFine.Performance({
                IsAscending:o?.asc == true,
                OrderColumnName:o?.key || null,
                QueryParam:this.searchValue,
                Skip:this.page,
                Take:this.perPage,
                StartDate:this.date[0] || null,
                EndDate:this.date[1] || null,
            }).then(res => {
                this.excelPath = res.data.Data.ExcelPath || null
                this.summary.totalDriverAmountStr = res.data.Data.TotalDriverAmountStr || '0,00 ₺'
                this.summary.totalCompanyAmountStr = res.data.Data.TotalCompanyAmountStr || '0,00 ₺'
                this.summary.totalFineAmountStr = res.data.Data.TotalAmountStr || '0,00 ₺'
                this.getting = false
                this.datas = (res.data.Data.Data.Data || []).map(s => ({...s,_expand:false}))
                this.count = res.data.Data.Data.TotalCount || 0
            }).catch(err => {
                this.getting = false
            })
        }
    },
    computed:{
        orders(){
            return this.columns.reduce((arr,i) => {
                arr.push({id:`${i.key}-true`,...i,asc:true})
                arr.push({id:`${i.key}-false`,...i,asc:false})
                return arr
            },[])
        }
    }
}
</script>
